import { EmailBox } from '@apply/components';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SecondaryEmailField = () => {
    const value = useBrokerDetailsStore((s) => s.secondaryEmail);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.SecondaryEmail);
    return (
        <>
            <EmailBox
                id='cSecondaryEmail'
                value={value}
                onChange={(v) => updateFields({ secondaryEmail: v })}
                width={'100%'}
                label='Alternative Email Address'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
